export const URL = process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000'
    : 'https://damp-bastion-57029.herokuapp.com'
